<template>
  <v-footer absolute>
    <v-row no-gutters class="text-center">
      <v-col cols="6">
        <v-img
          alt="Client Logo"
          class="shrink ml-auto mr-0"
          contain
          :src="require('../assets/PIXL8---Final-sml.png').default"
          transition="scale-transition"
          width="140"
        />
        <router-link :to="{ name: 'Welcome' }"></router-link>
      </v-col>
      <v-col cols="6">
        <v-img
          alt="Client Logo"
          class="shrink ml-0 mt-2"
          contain
          :src="require('../assets/eXPD8-UK-logo---No-whoosh---DG.png').default"
          transition="scale-transition"
          width="140"
          height="32"
        />
      </v-col>

      {{ new Date().getFullYear() }} — <strong>eXPD8</strong>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>
